module.exports = __webpack_public_path__ + "images/giftTree/horoscope.c301a8930476afed632503f329a64ef2.png";